import React from 'react';
import { useDispatch } from 'react-redux';

import { Checkbox } from '../Form/Field/Checkbox';

import InterestUri from '../../../Enum/InterestUri';
import { Label } from '../../../Interface/Response/Interest/Label';
import { Property } from '../../../Interface/Response/ProductProperty/List/PropertiesByCategory';

import { filterValueSelected } from '../../../Store/Pdf/action';
import useGetLabels from '../../../Hook/Interest/UseGetLabels';
import useGetProperties from '../../../Hook/Interest/UseGetProperties';
import { isPropertyArea } from '../../../Helpers/Interest/PdfHelper';

interface Props {
    filterValues: string[];
    section: InterestUri;
}

interface CheckBoxProps {
    value: string;
    label: string;
}

const makeCheckboxes = (
    filterValues: string[],
    section: InterestUri,
    allLabels: Label[],
    properties: Property[],
): CheckBoxProps[] => {
    if (isPropertyArea(section)) {
        return filterValues.map(value => ({
            value,
            label: (properties.find(property => property.code === value) as Property).name,
        }));
    }

    return filterValues.map(value => ({
        value,
        label: (allLabels.find(label => label.findataCode === value) as Label).label,
    }));
}

const PdfSelectFilterValues: React.FC<Props> = ({ filterValues, section }: Props) => {
    const dispatch = useDispatch();
    const { allLabels } = useGetLabels(true);
    const properties = useGetProperties();
    const checkboxes = makeCheckboxes(filterValues, section, allLabels, properties);

    return (
        <>
            <p>Maak een selectie van maximaal drie uit de volgende keuzes:</p>
            <div className="d-flex">
                <div className="col-6">
                    {checkboxes.filter((value, index) => index % 2 === 0).map(value => (
                        <Checkbox id={value.value}
                                  label={value.label}
                                  checked={false}
                                  onChange={() => dispatch(filterValueSelected(value.value))}
                                  key={value.value}
                        />
                    ))}
                </div>
                <div className="col-6">
                    {checkboxes.filter((value, index) => index % 2 === 1).map(value => (
                        <Checkbox id={value.value}
                                  label={value.label}
                                  checked={false}
                                  onChange={() => dispatch(filterValueSelected(value.value))}
                                  key={value.value}
                        />
                    ))}
                </div>
            </div>
        </>
    );
}

export default PdfSelectFilterValues;
